import React from "react";

import "./style.css";

const gradient = () => {
  return (
    <div>
      <div className="gradient"></div>
      <div className="gradient__small"></div>
    </div>
  );
};

export default gradient;
